import Tile from '../Shared/Tiles/TileV2';
import { Tab, Tabs } from '@lmig/lmds-react-tabs';
import '../TwoTabTile/TwoTabTile.scss';
import '../Shared/Tiles/ImageRichTextTile.scss';
import '../RecentActivities/RecentActivitiesTable.scss';
import { getFooterDateYesterday } from '../RecentActivities/RecentActivitiesHelper';
import { JSX, useEffect, useState } from 'react';
import { Popover } from '@lmig/lmds-react-popover';
import { IconButton, IconInfo } from '@lmig/lmds-react-icons';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HandleErrorBoundaryCatch } from 'Utilities/ErrorHelper';

export interface ITwoTabTile {
  tileTitle: string;
  tileLinkURL: string;
  tileLinkText: string;
  tileLinkTarget: string;
  tileLinkAltText: string;
  hideAgencyCode: boolean;
  tabs: ITileActivityTab[];
}

export interface ITileActivityTab {
  title: string | null;
  titlePopoverText?: string | null;
  body: JSX.Element | null;
  hideAsOfDate?: boolean | null;
  footer?: JSX.Element | null;
  tabClassName?: string | null;
}

export const TwoTabTile: React.FunctionComponent<any> = (props: ITwoTabTile) => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [footer, setFooter] = useState<JSX.Element | null>(null);
  const [popoverIsOpen, setPopoverIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setFooter(!props?.tabs[activeTab]?.hideAsOfDate
      ? props?.tabs[activeTab]?.footer !== null && props?.tabs[activeTab]?.footer !== undefined
        ? props?.tabs[activeTab]?.footer
        : <div className="tile-footer-date">{getFooterDateYesterday()}</div>
      : <></>
    );
  }, [activeTab, props?.tabs[activeTab]?.hideAsOfDate, props?.tabs[activeTab]?.footer]);

  const RenderFooter = () => {
    return footer;
  }
  
  const onPopoverOpen = () => {
    setPopoverIsOpen(true);
  };

  const onPopoverClose = () => {
    setPopoverIsOpen(false);
  }

  return props
    ? <ErrorBoundary fallback={<HandleErrorBoundaryCatch component={"TwoTabTile"} message={"TwoTabTile render error"} />}>
        <div data-theme="evolved" className="two-tab-tile">
          <Tile
            title={props.tileTitle}
            headerLinkHref={props.tileLinkURL}
            headerLinkText={props.tileLinkText}
            target={props.tileLinkTarget}
            showStatCode={!props.hideAgencyCode === true}
          >
            <Tabs 
              className={`${popoverIsOpen ? 'popover-open' : 'popover-closed'}`} 
              activeTab={activeTab} 
              onTabActivated={(event, index) => setActiveTab(index)}
              compact={true}
              // mobileTabLimit={2} // won't render a dropdown with less than 3 tabs
            >
              {props?.tabs.map((tab) => (
                <Tab
                  className={`${tab.tabClassName ?? ''}`}
                  labelVisual={
                    <span>
                      {tab?.titlePopoverText !== null && tab.titlePopoverText !== undefined && tab.titlePopoverText.length > 0 ? (
                        <div>
                          {`${tab.title} `}
                          <Popover
                            direction="auto"
                            align="start"
                            className="two-tab-tile-popover"
                            variant="iconAndText"
                            flexWidth={true}
                            autoFlip={false}
                            focusLock={true}
                            onOpen={onPopoverOpen}
                            onClose={onPopoverClose}
                            trigger={
                              <IconButton background="transparent">
                                <IconInfo color="teal" size="16" />
                              </IconButton>
                            }
                          >
                            <div>{tab.titlePopoverText}</div>
                          </Popover>
                        </div>
                      ) : (
                        <div>{tab.title}</div>
                      )}
                    </span>
                  }
                >
                  {tab.body}
                </Tab>
              ))}
            </Tabs>
            <div>
              <RenderFooter />
            </div>
          </Tile>
        </div>
      </ErrorBoundary>
    : <></>
  ;
};
